import { SIMPLY_LISTINGS_PACKAGE_IDS } from '../dictionary/subscription';

/** Returns true when the package ID belongs to the Simply Listings / CB-only package group. */
export const isSimplyListingsPackage = (packageId?: string | null) =>
  SIMPLY_LISTINGS_PACKAGE_IDS.some((id) => id === packageId);
